/** Runs a structural operation against the draft as it stands at the click (never a
 *  render-time snapshot): dispatches its one SET, or says why it was refused — the records
 *  outline's runner (`useOutlineRun`), with the tour's names for the labels. Stable. */
import { useCallback } from 'react';

import { useOutlineRun } from '@/features/records/outline/store';

import { useTourRecord } from '../record/TourRecordContext';

import type { StructureContext, StructureResult } from './structure';

export type StructureOp = (ctx: StructureContext) => StructureResult | null;

/** `run(op)` → the new row's id (an add), true (done), or null (nothing / refused). */
export function useStructure(): (op: StructureOp) => number | true | null {
  const run = useOutlineRun();
  const { names } = useTourRecord();
  return useCallback(
    (op) => run((c) => op({ state: c.state, baselines: c.baselines, tourRec: c.ownerRec, names })),
    [run, names],
  );
}
